import { createRouter, createWebHistory } from 'vue-router'
import ListenPage from '@/views/Listen.vue'
import WatchPage from '@/views/WatchPage.vue'
import LoginPage from '@/views/LoginPage.vue'
import RegisterPage from '@/views/RegisterPage.vue'
import ActivatePage from '@/views/ActivatePage.vue'
import AdminPage from '@/views/AdminPage.vue'
import AboutUsPage from '@/views/AboutUs.vue'
import store from '@/store'

const routes = [
  {
    path: '/',
    redirect: '/listen'
  },
  {
    path: '/listen',
    name: 'Listen',
    component: ListenPage
  },
  {
    path: '/watch',
    name: 'Watch',
    component: WatchPage
  },
  {
    path: '/about',
    name: 'AboutUs',
    component: AboutUsPage
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterPage
  },
  {
    path: '/activate',
    name: 'Activate',
    component: ActivatePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminPage,
    meta: { requiresAuth: true, requiresAdmin: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated
  const isAdmin = store.getters.isAdmin
  
  // 如果访问的路由需要登录
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      // 未登录时重定向到登录页
      next({ name: 'Login' })
    } else if (to.matched.some(record => record.meta.requiresAdmin) && !isAdmin) {
      // 非管理员访问管理员页面时重定向到首页
      next({ name: 'Listen' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router 